import { render } from "./BuscaGeral.vue?vue&type=template&id=75b5e84d&scoped=true&ts=true"
import script from "./BuscaGeral.vue?vue&type=script&lang=ts"
export * from "./BuscaGeral.vue?vue&type=script&lang=ts"

import "./BuscaGeral.vue?vue&type=style&index=0&id=75b5e84d&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b5e84d"]])

export default __exports__